export default (
	options = []
) => ({
	options,
	multiple: false,
	topic: '',
	available_topics: [],
	ready: false, 
	init() {
		this.$nextTick( () => {
			let topic = new URLSearchParams(location.search).get('topic');
			if ( topic ) {
				this.topic = topic;
				this.$dispatch('filter', { field: 'topic', value: topic });
			}
			this.ready = true;
		} );
		this.$watch('topic', (value) => {
			if ( !this.ready ) { return; }

			const url = new URL(window.location.href);
			url.searchParams.set('topic', value);
			history.pushState(null, document.title, url.toString());
			this.$dispatch('filter', { field: 'topic', value });
		});
	},
	get available_options() {
		if ( this.available_topics.length === 0 ) { return this.options; }
		return this.options.filter( (option) => {
			return option.value === '*' || this.available_topics.includes(option.value);
		} );
	}
});

